import React from 'react';
import { Link } from 'react-router-dom';
import Icon from '../AppIcon';

const Footer = () => {
  const footerLinks = {
    company: {
      title: 'Company',
      links: [
        { name: 'About Us', path: '/about' },
        { name: 'Corporate Structure', path: '/corporate-structure' },
        { name: 'Leadership', path: '/corporate-structure#leadership' },
        { name: 'Careers', path: '/careers' },
      ],
    },
    technology: {
      title: 'Technology',
      links: [
        { name: 'Platform Overview', path: '/technology' },
        { name: 'Technical Stack', path: '/technology#stack' },
        { name: 'API & Integrations', path: '/technology#api' },
        { name: 'Security', path: '/compliance#security' },
      ],
    },
    resources: {
      title: 'Resources',
      links: [
        { name: 'Investor Relations', path: '/investor-relations' },
        { name: 'Partnerships', path: '/partnerships' },
        { name: 'Press & Media', path: '/press' },
        { name: 'Impact Report', path: '/impact' },
      ],
    },
    legal: {
      title: 'Legal',
      links: [
        { name: 'Privacy Policy', path: '/compliance#privacy' },
        { name: 'Terms of Service', path: '/compliance#terms' },
        { name: 'Compliance', path: '/compliance' },
        { name: 'Cookie Policy', path: '/compliance#cookies' },
      ],
    },
  };

  const socialLinks = [
    { name: 'LinkedIn', icon: 'Linkedin', url: 'https://linkedin.com/company/united-empresas' },
    { name: 'Twitter', icon: 'Twitter', url: 'https://twitter.com/unitedempresaas' },
  ];

  const currentYear = new Date().getFullYear();

  return (
    <footer className="bg-primary text-white">
      {/* Main Footer */}
      <div className="max-w-wide mx-auto px-4 lg:px-8 py-16">
        <div className="grid grid-cols-2 md:grid-cols-4 lg:grid-cols-5 gap-8 lg:gap-12">
          {/* Brand Column */}
          <div className="col-span-2 md:col-span-4 lg:col-span-1 mb-8 lg:mb-0">
            <Link to="/" className="flex items-center space-x-3 mb-6">
              <div className="flex items-center justify-center w-9 h-9 bg-white/10 rounded-lg">
                <svg
                  width="20"
                  height="20"
                  viewBox="0 0 24 24"
                  fill="none"
                  className="text-white"
                >
                  <path
                    d="M12 2L2 7L12 12L22 7L12 2Z"
                    stroke="currentColor"
                    strokeWidth="2"
                    strokeLinejoin="round"
                    fill="currentColor"
                    fillOpacity="0.2"
                  />
                  <path
                    d="M2 17L12 22L22 17"
                    stroke="currentColor"
                    strokeWidth="2"
                    strokeLinejoin="round"
                  />
                  <path
                    d="M2 12L12 17L22 12"
                    stroke="currentColor"
                    strokeWidth="2"
                    strokeLinejoin="round"
                  />
                </svg>
              </div>
              <span className="text-lg font-semibold">United Empresas</span>
            </Link>
            <p className="text-sm text-white/60 mb-6 max-w-xs">
              Building the infrastructure for the service economy in Latin America.
            </p>
            <div className="flex space-x-4">
              {socialLinks.map((social) => (
                <a
                  key={social.name}
                  href={social.url}
                  target="_blank"
                  rel="noopener noreferrer"
                  className="w-9 h-9 flex items-center justify-center rounded-lg bg-white/10 hover:bg-white/20 transition-colors duration-150"
                  aria-label={social.name}
                >
                  <Icon name={social.icon} size={18} />
                </a>
              ))}
            </div>
          </div>

          {/* Link Columns */}
          {Object.values(footerLinks).map((column) => (
            <div key={column.title}>
              <h4 className="text-sm font-semibold mb-4">{column.title}</h4>
              <ul className="space-y-3">
                {column.links.map((link) => (
                  <li key={link.path}>
                    <Link
                      to={link.path}
                      className="text-sm text-white/60 hover:text-white transition-colors duration-150"
                    >
                      {link.name}
                    </Link>
                  </li>
                ))}
              </ul>
            </div>
          ))}
        </div>
      </div>

      {/* Bottom Bar */}
      <div className="border-t border-white/10">
        <div className="max-w-wide mx-auto px-4 lg:px-8 py-6">
          <div className="flex flex-col md:flex-row justify-between items-center space-y-4 md:space-y-0">
            <div className="text-sm text-white/60">
              © {currentYear} United Empresas Global Holdings, Inc. All rights reserved.
            </div>
            <div className="flex items-center space-x-6 text-sm text-white/60">
              <span>Delaware C-Corp</span>
              <span className="w-1 h-1 rounded-full bg-white/40"></span>
              <span>Santo Domingo</span>
              <span className="w-1 h-1 rounded-full bg-white/40"></span>
              <span>New York</span>
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
